import { ZepIcon_default } from './chunk-SGEFWXJL.mjs';
import { jsx } from 'react/jsx-runtime';

var ArrowTurnDownrightIcon = ZepIcon_default(
  (props) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props, children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M18.424 14.867a.997.997 0 0 1-.217 1.09l-3 3a1 1 0 0 1-1.414-1.414l1.293-1.293H10a5 5 0 0 1-5-5v-5.5a1 1 0 0 1 2 0v5.5a3 3 0 0 0 3 3h5.086l-1.293-1.293a1 1 0 0 1 1.414-1.414l3 3M18.424 14.867a.997.997 0 0 0-.215-.322l.215.322Z",
      fill: props.fill || "currentColor"
    }
  ) })
);

export { ArrowTurnDownrightIcon };
